<template>
  <el-dialog
    :model-value="true"
    title="积分充值" 
    align-center 
    width="45rem"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="pay-integral-body"
  >
    <template #default>
      <div class="pay-attr-div">
        <div class="attr-prop">订单编号</div>
        <div class="attr-content">{{ order['orderNumber'] }}</div>
      </div>
      <div class="pay-attr-div">
        <div class="attr-prop">备注</div>
        <div class="attr-content">
          <el-input v-model="order['orderRemarks']" placeholder="请输入..." 
            size="small" clearable
          />
        </div>
      </div>
      <table class="pay-info-table" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th>积分</th>
            <th>折扣</th>
            <th>金额</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ order['integral'] }}</td>
            <td>{{ order['priceDiscount'] }}%</td>
            <td>&yen;{{ order['amount'] }}</td>
          </tr>
        </tbody>
      </table>
      <div class="pay-ment">
        <div class="pay-attr-div">
          <div class="attr-prop">
            
          </div>
        </div>
        <el-scrollbar class="pay-ment-content" v-mousescroll>
          <div class="pay-ment-div"
            v-for="(item, index) in payMentList" :key="item"
            :class="{
              'pay-ment-check': payMentIndex == index,
            }"
            @click="payMentClick(index)"
          >
            <svg-icon :iconName="item.icon" :fillColor="item.fill"></svg-icon>
            <div class="pay-name">
              {{ item.name }}<br>
              {{ item.englishName }}
            </div>
            <div class="check-icon" v-if="payMentIndex == index">
              <svg-icon iconName="circle-check" fillColor="#fff"></svg-icon>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="pay-total">
        总计：<span>&yen;{{ order['amount'] }}</span>&nbsp;元
      </div>
    </template>
    <template #footer>
      <el-button 
        type="danger" size="small" @click="closeFn">
        <template #icon>
          <svg-icon iconName="el-CircleClose"></svg-icon>
        </template>
        取消
      </el-button>
      <el-popover
        placement="bottom"
        trigger="hover"
        width="max-content"
        popper-class="pay-popper-content"
      >
        <template #default>
          <el-button type="primary" size="small" @click="checkPay"
            icon="CircleCheck"
            :loading="order['checkPayLoad']"
          >
            已支付完成
          </el-button>
        </template>
        <template #reference>
          <el-button
            type="primary" size="small" 
            icon="CircleCheck"
            :loading="order['submitLoad']"
            @click="submitFn"
          >
            支付
          </el-button>
        </template>
      </el-popover>
    </template>
  </el-dialog>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
// props
const props = defineProps({
  order: { type: Object, required: true, },
});
// emit
const emit = defineEmits([
  'close', 'submit', 'checkPay',
]);

const closeFn = ()=>{
  emit('close');
}
const submitLoad = ref('payLoad');
const submitFn = ()=>{
  props.order[submitLoad.value] = true;
  emit('submit', props.order, ()=>{
    props.order[submitLoad.value] = false;
  });
}
const checkPayLoad = ref('checkPayLoad');
const checkPay = ()=>{
  props.order[checkPayLoad.value] = true;
  emit('checkPay', props.order, ()=>{
    props.order[checkPayLoad.value] = false;
  });
}

const remarkVal = ref('');
const payMentList = ([
  // { name: '微信', englishName: 'WeChat Pay', icon: 'wechat-pay', fill: 'rgb(0, 172, 28)', },
  { name: '支付宝', englishName: 'ALI PAY', icon: 'alipay-pay', fill: 'rgb(28, 123, 255)', },
])
const payMentIndex = ref(0);
const payMentClick = (index)=>{
  payMentIndex.value = index;
}
// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>
.pay-popper-content{
  min-width: 0 !important;
}
.pay-integral-body{
  border-radius: 10px;
  box-shadow: var(--boxShadow);
  .pay-total{
    padding: 0 5px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    span{
      color: red;
      font-size: 20px;
    }

  }
  .pay-ment{
    display: flex;
    margin-top: 10px;
    .pay-ment-content{
      --mentDivHeight: 42px;
      --borderSize: 2px;
      flex: 1;
      padding: 0 5px;
      .el-scrollbar__view{
        height: var(--mentDivHeight);
        display: inline-flex;
      }
      .pay-ment-div{
        border: var(--borderSize) solid var(--borderColor);
        border-radius: 5px;
        width: 180px;
        height: var(--mentDivHeight);
        cursor: pointer;
        margin-right: 10px;
        position: relative;
        overflow: hidden;
        &:last-child{
          margin-right: 0;
        }
        &:hover{
          background-color: var(--backgroundColorOpacity);
          border: var(--borderSize) solid var(--borderColor);
        }
        .svg-icon{
          --svgMagSize: 5px;
          --iconSize: calc(
            var(--mentDivHeight) - var(--borderSize)*2 - var(--svgMagSize)*2
          );
          height: var(--iconSize);
          width: var(--iconSize);
          margin: var(--svgMagSize);
        }
        display: flex;
        --innerHeigth: calc(var(--mentDivHeight) - var(--borderSize)*2);
        .pay-name{
          height: var(--innerHeigth);
          line-height: calc(var(--innerHeigth) / 2);
          padding: 0 5px;
          font-size: 14px;
        }
        .check-icon{
          position: absolute;
          right: 0;
          top: 0;
          border-width: calc(var(--innerHeigth) / 2);
          border-style: solid;
          border-color: var(--borderColor) var(--borderColor) transparent transparent;
          .svg-icon{
            position: absolute;
            top: calc(var(--innerHeigth) / -2);
            right: calc(var(--innerHeigth) / -2);
            height: 14px;
            width: 14px;
          }
        }
      }
      .pay-ment-check{
        border: var(--borderSize) solid var(--borderColor);
      }
    }
  }
  .pay-info-table{
    margin: 20px auto;
    border: 2px solid var(--borderColor);
    border-radius: 5px;
    tr{
      td,th{
        min-width: 100px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-right: 2px solid var(--borderColor);
        border-bottom: 2px solid var(--borderColor);
        &:last-child{
          border-right: none;
        }
        padding: 0 5px;
      }
      &:last-child{
        td{
          border-bottom: none;
        }
      }
    }
  }
  --attrDivHeight: 24px;
  .pay-attr-div{
    display: flex;
    font-size: 14px;
    height: var(--attrDivHeight);
    .attr-prop{
      width: 140px;
      text-align: right;
      font-weight: bold;
      height: var(--attrDivHeight);
      line-height: var(--attrDivHeight);
      padding: 0 5px;
    }
    .attr-content{
      height: var(--attrDivHeight);
      line-height: var(--attrDivHeight);
      flex: 1;
      padding: 0 5px;
    }
  }
}

</style>

<style lang='less' scoped>
</style>